import { useMemo } from "react";
import { Box, Container, Link, Stack, Text } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import {
  COMPANY_NAME,
  HOW_TO_GUIDE_URL,
  PRIVACY_AND_COOKIE_STATEMENT_URL,
  TERMS_AND_CONDITONS_URL,
} from "../../constants/application";
import styles from "./Footer.module.css";

type FooterNavItem = {
  label: string;
  href: string;
};

export const Footer = () => {
  const i18n = useI18n();

  const navItems: FooterNavItem[] = useMemo(
    () => [
      { label: i18n.trans(t("flights_airline_portal_footer_bar_privacy")), href: PRIVACY_AND_COOKIE_STATEMENT_URL },
      { label: i18n.trans(t("flights_airline_portal_footer_bar_terms")), href: TERMS_AND_CONDITONS_URL },
      { label: i18n.trans(t("flights_airline_portal_footer_bar_user_guide")), href: HOW_TO_GUIDE_URL },
    ],
    [i18n]
  );

  return (
    <Box tagName="footer" backgroundColor="brand_primary" padding={0}>
      <Container>
        <Box
          mixin={{
            paddingBlockStart: 6.5,
            paddingBlockEnd: 6.5,
            paddingInlineStart: 0,
            paddingInlineEnd: 0,
          }}
        >
          <Stack gap={6}>
            <Stack direction="row" justifyContent="space-between">
              <nav aria-label={i18n.trans(t("flights_airline_portal_footer_bar_navigation"))}>
                <Stack tagName="ul" direction="row" gap={4} className={styles.navItems}>
                  {navItems.map((item) => (
                    <Stack.Item tagName="li" key={item.label}>
                      <Link
                        href={item.href}
                        attributes={{ target: "_blank", rel: "noopener noreferrer" }}
                      >
                        <Text variant="body_2" color="white" decoration="underline">
                          {item.label}
                        </Text>
                      </Link>
                    </Stack.Item>
                  ))}
                </Stack>
              </nav>
              <Stack>
                <Stack.Item>
                  <Text tagName="span" variant="body_2">
                    {i18n.trans(
                      t("flights_airline_portal_footer_bar_copyright", {
                        variables: {
                          b_companyname: COMPANY_NAME,
                          current_year: new Date().getFullYear(),
                        },
                      })
                    )}
                  </Text>
                </Stack.Item>
              </Stack>
            </Stack>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};
